module.exports = __webpack_public_path__ + "static/media/sort-size-up.81b17a8e.svg";